export default function isUsedLocalStorage() {
  try {
    if (typeof window === 'undefined') {
      return false
    }

    window.localStorage.setItem('__localStorageTest', '')
    window.localStorage.removeItem('__localStorageTest')

    return true
  } catch (error) {
    return false
  }
}
